/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/shield_medium'
export default icon
